import { Injectable } from '@angular/core';
import { SampleTrackingStorage } from '../sample-tracking-storage';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SampleTrackingDialogService } from '../service/dialog-service/sample-tracking-dialog-service';
import { CreateGroupRequest } from '../create-study-group/create-group-request';
import { SampleTrackingDialogResult } from './dialog-service/sample-tracking-result';
import { StudyGroupInfo } from '../group-info/study-group-info';
import { EditGroupRequest } from '../edit-study-group/edit-study-group-request';

@Injectable()
export class SampleTrackingActionService {

    private isSuccess = false;

    private messageText: string;

    constructor(private readonly dialogService: SampleTrackingDialogService,
                private readonly sampleTrackingStorage: SampleTrackingStorage) {
    }

    public async createGroup(request: CreateGroupRequest) {
        try {
            (await this.sampleTrackingStorage.createStudyGroup(request)).toPromise()
                .then(() => {
                    this.isSuccess = true;
                    this.messageText = 'Study Grouping has been successfully created!';
                    this.openDialog();
                    this.sampleTrackingStorage.forceLoadAll();

                })
                .catch(() => {
                    this.isSuccess = false;
                    this.messageText = 'Study Grouping not created!';
                    this.openDialog();
                    this.sampleTrackingStorage.forceLoadAll();

                });
        } catch (e) {
            this.isSuccess = false;
        }

    }


    public async deleteStudyGroup(studyGroupPk: number) {

        try {
            (await this.sampleTrackingStorage.deleteStudyGroup(studyGroupPk)).toPromise()
                .then(() => {
                    this.isSuccess = true;
                    this.messageText = 'Study Grouping has been successfully deleted!';
                    this.openDialog();
                    this.sampleTrackingStorage.forceLoadAll();
                })
                .catch(() => {
                    this.isSuccess = false;
                    this.messageText = 'Study Grouping not deleted!';
                    this.openDialog();
                    this.sampleTrackingStorage.forceLoadAll();

                });
        } catch (e) {
            this.isSuccess = false;
        }
    }

    public async editStudyGroup(request: EditGroupRequest) {

        try {
           (await this.sampleTrackingStorage.editStudyGroup(request)).toPromise()
               .then(() => {
                   this.isSuccess = true;
                   this.messageText = 'Study Grouping has been successfully updated!';
                   this.openDialog();
                   this.sampleTrackingStorage.forceLoadAll();
               })
               .catch(() => {
                   this.isSuccess = false;
                   this.messageText = 'Study Grouping not updated!';
                   this.openDialog();
                   this.sampleTrackingStorage.forceLoadAll();

               });
        } catch (e) {
           this.isSuccess = false;
        }
    }

    private openDialog() {
        this.dialogService.showPostActionDialogue(this.messageText, this.isSuccess);
    }
}